import React from 'react';
import { get } from 'lodash';

import ParamsBlock from "./paramsBlock"

import { sexData } from "./../sex/static.sexData"
import { heightTypeData } from "./../height/static.heightData"
import { workHardData } from "./../workHard/static.workHardData"
import { ftToCm } from "./../../../utils/converter"
import locales from "./../../../content.json"

import styles from "./caloriesResultBlock.module.scss"

const MIN_VALUE = 1000
const MAX_VALUE = 5000
const CALORIES_RANGE = 100

const inRange = value => {
  return value < MIN_VALUE
    ? MIN_VALUE
    : value > MAX_VALUE
      ? MAX_VALUE
      : value
}

const getCalories = data => {
  const height = get(data, ["height", "type"]) === heightTypeData.ft.value
    ? ftToCm(get(data, ["height", "value"]))
    : get(data, ["height", "type"]) === heightTypeData.cm.value
      ? get(data, ["height", "value"])
      : get(data, ["height", "value"])

  if (get(data, ["sex", "value"]) === sexData.male.value)
    return (10 * get(data, ["currentWeight", "value"]) + 6.25 * height - 5 * get(data, ["old", "value"]) + 5) * workHardData[get(data, ["workHard", "value"])].a

  else if (get(data, ["sex", "value"]) === sexData.female.value)
    return (10 * get(data, ["currentWeight", "value"]) + 6.25 * height - 5 * get(data, ["old", "value"]) - 161) * workHardData[get(data, ["workHard", "value"])].a

  else
    return (10 * get(data, ["currentWeight", "value"]) + 6.25 * height - 5 * get(data, ["old", "value"]) - 161) * workHardData[get(data, ["workHard", "value"])].a
}

const CaloriesResultBlock = props => {
  const { data } = props
  const maxCalories = Math.ceil(getCalories(data) / 100) * 100
  const minCalories = maxCalories - CALORIES_RANGE

  const left = (inRange(minCalories) - MIN_VALUE) / (MAX_VALUE - MIN_VALUE) * 100
  const right = (inRange(maxCalories) - MIN_VALUE) / (MAX_VALUE - MIN_VALUE) * 100
  const width = right - left

  return (
    <ParamsBlock
      title={locales[window.userLang].calories}
      helpText={<span>{locales[window.userLang].recommended_daily}</span>}
      value={`${minCalories} - ${maxCalories} ${locales[window.userLang].calories_value}`}
    >
      <div className={styles.caloriesGrafic}>
        <div className={styles.categoryLine}>
          <span style={{ width: width + "%", left: left + "%" }}></span>
        </div>
        <div className={styles.graficValues}>
          <span>{MIN_VALUE} {locales[window.userLang].calories_value}</span>
          <span>{MAX_VALUE} {locales[window.userLang].calories_value}</span>
        </div>
      </div>
    </ParamsBlock>
  )
}

export default CaloriesResultBlock;